import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CallIcon from "@mui/icons-material/Call";
import "./contact.css";

const methods = [
  {
    icon: <EmailIcon />,
    label: "Email",
    value: "gopalgoyal612002@gmail.com",
    href: "mailto:gopalgoyal612002@gmail.com",
  },
  {
    icon: <CallIcon />,
    label: "Phone",
    value: "+91 96852 60286",
    href: "tel:+919685260286",
  },
  {
    icon: <LinkedInIcon />,
    label: "LinkedIn",
    value: "in/gopal-goyal",
    href: "https://www.linkedin.com/in/gopal-goyal-863981175/",
  },
  {
    icon: <GitHubIcon />,
    label: "GitHub",
    value: "gopalgoyal2002",
    href: "https://github.com/gopalgoyal2002",
  },
];

export default function ContactComponent() {
  return (
    <section className="section section--soft" id="contact">
      <div className="section-inner">
        <h2 className="section-title">Get in Touch</h2>
        <span className="section-title-accent" />
        <p className="section-subtitle">
          Open to interesting AI and full-stack opportunities and collaborations.
          The fastest way to reach me is email.
        </p>

        <div className="contact-grid">
          {methods.map((m) => {
            const external = m.href.startsWith("http");
            return (
              <a
                key={m.label}
                href={m.href}
                className="contact-card"
                {...(external
                  ? { target: "_blank", rel: "noreferrer" }
                  : {})}
              >
                <span className="contact-icon">{m.icon}</span>
                <span className="contact-meta">
                  <span className="contact-label">{m.label}</span>
                  <span className="contact-value">{m.value}</span>
                </span>
              </a>
            );
          })}
        </div>

        <div className="contact-cta">
          <a
            href="mailto:gopalgoyal612002@gmail.com?subject=Hello%20Gopal"
            className="btn btn-primary"
          >
            <EmailIcon fontSize="small" /> Say hello
          </a>
        </div>
      </div>
    </section>
  );
}
